module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori1-7648f16dec5788f1b5ad5afa7f7ba1b4.jpg";